import { useMemo } from 'react';
import { makePath } from 'utils/routes';

import type { ActivePath } from './ActivePaths';
import type { NavTree } from './SideNav';
import { setActiveNavTreePath } from './SideNav';
import { useLedgersNavTree } from './useLedgersNavTree';

type ProjectNavProps = {
  active: ActivePath;
  workspaceId: string;
  schemaKey?: string;
  ledgerId?: string;
  accountId?: string;
  groupId?: string;
  externalAccountId?: string;
};

export const useProjectNav = ({
  active,
  workspaceId,
  schemaKey,
  ledgerId,
  accountId,
  groupId,
}: ProjectNavProps): NavTree => {
  const ledgersNavTree = useLedgersNavTree({
    active,
    workspaceId,
    schemaKey,
    ledgerId,
    accountId,
    groupId,
  });
  return useMemo(() => {
    const navTree = {
      projects: {
        props: {
          href: makePath(['w', workspaceId, 'projects'], { absolute: true }),
          children: 'Projects',
        },
        visibleOverride:
          active.startsWith('projects.ledgers') ||
          active.startsWith('projects.schema'),
        subNav: {
          ...(schemaKey
            ? {
                schema: {
                  props: {
                    href: makePath(
                      ['w', workspaceId, 'projects', 'schema', schemaKey],
                      {
                        absolute: true,
                      }
                    ),
                    children: 'Schema',
                  },
                },
              }
            : {}),
          ...ledgersNavTree,
        },
      },
    };
    setActiveNavTreePath(navTree, active);
    return navTree;
  }, [ledgersNavTree, active, schemaKey, workspaceId]);
};
